import { TaskOutcome } from '@api/generated/graphql';

export const SPEED_TO_LEAD_OUTBOUND_TASK_TYPE = 'speed-to-lead-outbound';

export interface SpeedToLeadContact {
  name: string;
  phoneNumbers: string[];
  address: {
    street: string;
    unit: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
}

export interface SpeedToLeadTaskDetails {
  scriptOpener: string;
  summary: string;
  goal: string;
  history: string;
  refId: string;
  refType: string;
}

export interface SpeedToLeadTaskAttributes {
  tenantId: string;
  action: string;
  outboundNumber: string;
  contact: SpeedToLeadContact;
  taskDetails: SpeedToLeadTaskDetails;
  liveAnswerOutcomeOptions: TaskOutcome[];
  noAnswerOutcomeOptions: TaskOutcome[];
  hasMadeCall?: boolean;
  hasCallConnected?: boolean;
  hasCallEnded?: boolean;
}
